module.exports = __webpack_public_path__ + "img/i_my_menu_05.286bec01.svg";